import { api } from '@/utils/api';

interface UseUpdateNoteOptions {
    onSuccess?: (data?: unknown) => void;
    onError?: (message?: string) => void;
}

export function useUpdateNote(options: UseUpdateNoteOptions = {}) {
    const apiUtils = api.useUtils();

    const updateNoteMutation = api.platoUser.command.notes.update.useMutation({
        async onMutate({ noteId, title }) {
            const previousData = apiUtils.platoUser.query.notes.getNoteById.getData({ noteId });
            await apiUtils.platoUser.query.notes.getNoteById.cancel({ noteId });

            // Optimistically update the note with new data (only fields that exist in CrmNoteDTO)
            if (previousData) {
                apiUtils.platoUser.query.notes.getNoteById.setData(
                    { noteId },
                    {
                        ...previousData,
                        titleRich: title,
                    },
                );
            }
            return { previousData };
        },
        onError(error, { noteId }, context) {
            // Roll back to previous data on error
            if (context?.previousData) {
                apiUtils.platoUser.query.notes.getNoteById.setData({ noteId }, context.previousData);
            }
            apiUtils.platoUser.query.notes.getNoteById.invalidate({ noteId });
            options.onError?.(error instanceof Error ? error.message : String(error));
        },
        onSuccess({ event }, { noteId }) {
            // Invalidate related queries to refetch fresh data
            if (noteId) {
                apiUtils.platoUser.query.notes.getNoteById.invalidate({ noteId });
            }

            if (event?.event_id) {
                apiUtils.platoUser.query.events.getEventById.invalidate({ eventId: event?.event_id });
            }

            apiUtils.platoUser.query.customerActivity.getFeedList.withFilters.invalidate();
            apiUtils.platoUser.query.customerActivity.getFeedList.getPinnedNotes.invalidate();

            options.onSuccess?.();
        },
    });

    return updateNoteMutation;
}
